// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { UserLibraryEmptyStateGetString, StationsGetString, RecentlyDotplayedGetString, PodcastsGetString, LibraryGetString, LayoutGetString, GenresGetString } from './types.generated'

const userLibraryEmptyStateLocales = ['en-US'] as const

export const getStringUserLibraryEmptyState: UserLibraryEmptyStateGetString = i18nBundle('userLibraryEmptyState', userLibraryEmptyStateLocales).getString

const stationsLocales = ['en-US'] as const

export const getStringStations: StationsGetString = i18nBundle('stations', stationsLocales).getString

const recentlyDotplayedLocales = ['en-US'] as const

export const getStringRecentlyDotplayed: RecentlyDotplayedGetString = i18nBundle('recently.played', recentlyDotplayedLocales).getString

const podcastsLocales = ['en-US'] as const

export const getStringPodcasts: PodcastsGetString = i18nBundle('podcasts', podcastsLocales).getString

const libraryLocales = ['en-US'] as const

export const getString: LibraryGetString = i18nBundle('library', libraryLocales).getString
export const getStringLibrary: LibraryGetString = getString

const layoutLocales = ['en-US'] as const

export const getStringLayout: LayoutGetString = i18nBundle('layout', layoutLocales).getString

const genresLocales = ['en-US'] as const

export const getStringGenres: GenresGetString = i18nBundle('genres', genresLocales).getString

